/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";

export const TrustPilotDynamic = () => {
  const ref = React.useRef(null);

  React.useEffect(() => {
    if ((window as any).Trustpilot) {
      (window as any).Trustpilot.loadFromElement(ref.current, true);
    }
  }, []);

  return (
    <div
      ref={ref}
      className="trustpilot-widget"
      data-locale="en-US"
      data-template-id="5419b732fbfb950b10de65e5"
      data-businessunit-id="5c60c45458ba3f0001df80d4"
      data-style-height="48px"
      data-style-width="100%"
      data-theme="light"
    >
      <a
        href="https://www.trustpilot.com/review/wisr.com.au"
        target="_blank"
        rel="noopener noreferrer"
      >
        Trustpilot
      </a>
    </div>
  );
};
